import {
	isCompareAnalysisFiltersUsable,
	resolveStatisticsOverviewCompareDisabledHint,
} from '../../../filters/lib/statisticsCompareHelpers';
import { pickTrendFields } from '../../board/lib/statisticsPersistedCharts';

/** 趋势图有效 filters 的解析模式（页级严格 applied；编辑器 applied scope + draft 折线） */
export const TREND_CHART_FILTER_MODE = {
	/** 顶栏/KPI/导出/URL/总览：严格 applied */
	PAGE_APPLIED: 'page_applied',
	/** 图表编辑：applied scope + draft 折线，改即预览 */
	EDITOR: 'editor',
};

/** 是否将 draft 折线字段叠到 applied scope 上（查询与 chart bundle 须一致） */
export const shouldOverlayTrendChartDraft = ({ mode } = {}) => mode === TREND_CHART_FILTER_MODE.EDITOR;

/** 解析趋势图/折线对比 API 与 bundle 用的 filters */
export const resolveTrendChartFilters = ({ mode = TREND_CHART_FILTER_MODE.PAGE_APPLIED, applied = {}, draft = {} } = {}) => {
	if (!shouldOverlayTrendChartDraft({ mode })) {
		return applied;
	}
	return {
		...applied,
		...pickTrendFields(draft),
	};
};

/** 固定到看板 / 保存修改：draft 折线配置完整写入 */
export const resolveTrendChartSaveFilters = ({ applied = {}, draft = {} } = {}) => ({
	...applied,
	...pickTrendFields(draft),
});

/** 对比 UI 禁用态：页级跟 applied；编辑器跟 draft */
export const resolveTrendChartCompareUi = ({ mode = TREND_CHART_FILTER_MODE.PAGE_APPLIED, applied = {}, draft = {} } = {}) => {
	const uiFilters = mode === TREND_CHART_FILTER_MODE.EDITOR ? draft : applied;
	return {
		compareAnalysisDisabled: !isCompareAnalysisFiltersUsable(uiFilters),
		compareAnalysisDisabledHint: resolveStatisticsOverviewCompareDisabledHint({
			startDate: uiFilters?.startDate,
			endDate: uiFilters?.endDate,
		}),
	};
};
